import { Button } from '@mui/material';
import { useUserAccess } from '@ui-framework/index';
import { COMPANY_TYPE } from '@constants/app';
import IconLibrary from '../../../../IconLibrary';

function DispatchMap({ value }) {
  const userAccess = useUserAccess();
  if (
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR ||
    userAccess?.company?.companyType === COMPANY_TYPE.ADMIN
  ) {
    return (
      <Button
        size="medium"
        startIcon={<IconLibrary.Map />}
        variant="contained"
        onClick={() => {
          window.location.href = `/servicejobs/map/${value}`;
        }}
        color="primary">
        View Map
      </Button>
    );
  }
  return null;
}

export default DispatchMap;
